import { render, staticRenderFns } from "./videoPreview.vue?vue&type=template&id=ef0ba934&"
import script from "./videoPreview.vue?vue&type=script&lang=js&"
export * from "./videoPreview.vue?vue&type=script&lang=js&"
import style0 from "./videoPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports